import './style.scss';

import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, EffectCoverflow, Parallax } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/parallax';

/*
* Slider Blocks
*/
var wazablockSliderInit = ( block ) => {
    const sliders = block.find('.swiper');

    if ( sliders.length ) {
        const slider = sliders[0];
        let finalParams;

        const swiperArgs = {
            loop: true,
            slidesPerView: 1,
            modules: [ Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination, Scrollbar, Parallax ],
            autoplay: {
                enabled: false
            },
            navigation: {
                enabled: false
            },
            pagination: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            }
        };

        if ( slider.dataset.parameters != undefined && slider.dataset.parameters != ''  ) {
            const dataParameters = JSON.parse(slider.dataset.parameters);

            if (dataParameters.navigation && dataParameters.navigation.enabled == true) {
                dataParameters.navigation.prevEl = block.find('.swiper-button-prev')[0];
                dataParameters.navigation.nextEl = block.find('.swiper-button-next')[0];
            }

            if (dataParameters.pagination && dataParameters.pagination.enabled == true) {
                dataParameters.pagination.el = block.find('.swiper-pagination')[0];
                dataParameters.pagination.type = 'bullets';
                dataParameters.pagination.clickable = true;
            }

            if (dataParameters.scrollbar && dataParameters.scrollbar.enabled == true) {
                dataParameters.scrollbar.el = block.find('.swiper-scrollbar')[0];
            }

            if (dataParameters.autoplay && dataParameters.autoplay.enabled == true) {
                dataParameters.autoplay.enabled = true;
            }

            finalParams = {
                ...swiperArgs,
                ...dataParameters
            };
        } else {
            finalParams = swiperArgs;
        }

        const swiper = new Swiper( slider, finalParams);
    }

}

$( () => {
    $('.wazablocks-slider').each(function () {
        wazablockSliderInit( $(this) );
    });
});


// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction( 'render_block_preview/type=slider', wazablockSliderInit );
}